import Image from "next/image";
import { blogCoverSources } from "@/lib/blog-cover";

/**
 * A blog cover filling its (relative, sized) card slot: the static WebP
 * variants when the build made them (lib/blog-cover), next/image for
 * anything else.
 */
export default function BlogCoverImage({ src, sizes }: { src: string; sizes: string }) {
  const local = blogCoverSources(src);
  if (!local) return <Image src={src} alt="" fill sizes={sizes} className="object-cover" />;
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={local.src}
      srcSet={local.srcSet}
      sizes={sizes}
      alt=""
      loading="lazy"
      decoding="async"
      className="absolute inset-0 h-full w-full object-cover"
    />
  );
}
